<div class="row" [formGroup]="otherFeaturesForm">
  @for (feature of orderData.building_other_features; track feature; let i = $index) {
    <div class="col-md-4" >
      <div class="checkBox-wrapper">
        <label class="checkbox-container" >
          <input type="checkbox" [attr.checked]="feature.value ? true : null" [id]="feature.id" (click)="featureValueChanged($event , i )">
          <span class="checkmark"> </span>
        </label>
        <span class="checkbox-label">{{feature.label_ar}}</span>
      </div>
    </div>
  }
</div>
<div  class="row">
  <div class="save-btn-wrapper col-md-12">
    <app-action-button (submitAction)="save($event)"></app-action-button>
  </div>
</div>
